import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { isGiftOptions } from './constants'

const IsGiftFilter = ({ onChange, value = [] }) => {
  const { t } = useTranslation()
  const options = isGiftOptions(t)

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <div>
      <ComboBox value={value} label={t('Contiene regalos')} fullWidth handleChange={handleChange} menuItems={options} />
    </div>
  )
}

export default IsGiftFilter
